/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThreadRetryIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACcUlEQVR4nLWUu2sUURTGV/CBzyq+IkbtxMpHIaK4RQyMyT2PWbh7zmQj2JhGRBBxQSwkWge0VCzFP8EXhHRaSsQm2AhpJBG0iKJBlDOzdzO7zmp2TS4su3Nn9v7u98333VKpywGgu4nkYGktxsiI34cs80D6FbF6btUBiP4IkPxA1l9rAiGS/cg6Z4A1gSDp27B4HuJIBlcL8Lwd8N+QoaGxrXFc22u/y+XyeiC5jaxLBaDFniDA+hhIfgLLpPd+s805Tk4B6ftVgQDJxZAcJJmFSvW0zSPidiB51BNk2Ps9GFd1fHx8Q7rjuHocWGYyvzM1zrktmUKpAMlCVxAgeZDtWN8g6jGb895vBJI7Tf9JZh0nZzI12l8QgEXn/MBygVgm7duuiUaPBo8hs2fCAHaPefREixqSm419rUOWq0jyrXFvIY7HdqVni9U/xA1Ir9jDZgGQ3LNF0nssM7b4shq9C6zvHMmFFvXgD2FcrUXe78z8roweSBuZl0fy1N5Dpq56NpeYJVs4iqJNXSXF6v4HhGXeUcKhC8hyP6jBWC+H/zqW80jyAkg/m+/AOkWUDCPJNLC8/gdEzZqH3vttOTVPoqi2I71mnShqdv6zAiWaJgZRT7Z4HWsUbHMk151L+ixNQFIH0u+FgFQyyWAhhNN43moCWJ410lJvbpBk+q8K8hDzs0hysAdIPtp1OKcyqE61KtdXHV98J4hzSV8eYDEv9ToKIHOhcKG5QHqjZ0A7xFrtKsnhdN7i2eyG1K036YtmuYasH9oLuCJIeqih9of5xtnUKaKXulPi/EB6trQNKxWwvkSWL0D6yUpn6sIDvwEyveE5MaOUggAAAABJRU5ErkJggg==)
 */
export const ThreadRetryIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M19 16A3 3 0 1 0 21 21.25a1 1 0 0 1 1.32 1.5 4.98 4.98 0 0 1-8.3-3.75 4.99 4.99 0 0 1 8-4 1 1 0 0 1 2 0v3a1 1 0 0 1-1 1h-3a1 1 0 0 1 0-2h1.23A3 3 0 0 0 19 16ZM15.04 12.88c.17.1.38.1.55.01.27-.15.55-.28.83-.4.41-.16.52-.75.15-1L9.73 6.93a1 1 0 0 0-1.11 1.66l6.42 4.29ZM21.44 12.44c.34-.2.73-.35 1.14-.4l.38-.39a1 1 0 0 0 0-1.41l-9.19-9.2a1 1 0 0 0-1.41 0L12 1.4a1 1 0 0 0 0 1.41l.35.35-1 1.01a1 1 0 0 0 .08 1.58l9.13 6.43c.3.07.6.15.88.26ZM12.2 15.69c.25.17.59.07.74-.2a7 7 0 0 1 .47-.7.53.53 0 0 0-.1-.77L6.9 9.76a1 1 0 1 0-1.12 1.66l6.4 4.27ZM3.03 11.54l8.8 6.2c.16.1.24.29.22.48a7.07 7.07 0 0 0 .04 1.88.52.52 0 0 1-.14.45l-.3.3.35.35a1 1 0 0 1 0 1.41l-.35.35a1 1 0 0 1-1.41 0l-9.2-9.19a1 1 0 0 1 0-1.41l.7-.7a1 1 0 0 1 1.3-.12Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
